module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "y-radio button",
    class: {
      checked: _vm._value == _vm.label,
        disabled: _vm.disabled
    }
  }, [_c('span', {
    staticClass: "y-radio-box"
  }, [_c('y-button', {
    attrs: {
      "type": "ghost"
    },
    nativeOn: {
      "click": function($event) {
        _vm.valueOn($event)
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm._value),
      expression: "_value"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm._value, _vm.label)
    },
    on: {
      "click": function($event) {
        _vm._value = _vm.label
      }
    }
  })], 1), _vm._v(" "), (!_vm.$slots.default) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-15161d8c!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/radio/radio-button.vue
// module id = 453
// module chunks = 27